import { Helmet } from 'react-helmet-async';

import { CasErrorBoundary, CasPageContent } from 'src/compass/shared/components';
import { SiteLayout } from 'src/compass/application';

import PublicLayoutInfoContainer from './_publicLayoutInfo/components/PublicLayoutInfoContainer';

export default function PublicLayoutInfoPage() {
  return (
    <SiteLayout>
      {/* Composed from CasPageContent rather than CasPage because this page shows no heading -
          the container's subtitle names the layout instead - and CasPage always renders its
          required title. The browser-tab title still needs setting, hence Helmet here. */}
      <Helmet>
        <title>Column Definitions</title>
      </Helmet>
      <CasErrorBoundary>
        <CasPageContent>
          <PublicLayoutInfoContainer />
        </CasPageContent>
      </CasErrorBoundary>
    </SiteLayout>
  );
}
